<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Gone in a Flash</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>A Selection of Recent Titles by Susan Rogers Cooper</em></h3>
<h4 class="books-by-subtitle"><em>The E J Pugh Mysteries</em></h4>
<p class="books-by-text-1">ONE, TWO, WHAT DID DADDY DO?</p>
<p class="books-by-text-1">HICKORY DICKORY STALK</p>
<p class="books-by-text-1">HOME AGAIN, HOME AGAIN</p>
<p class="books-by-text-1">THERE WAS A LITTLE GIRL</p>
<p class="books-by-text-1">A CROOKED LITTLE HOUSE</p>
<p class="books-by-text-1">NOT IN MY BACK YARD</p>
<p class="books-by-text-1">DON’T DRINK THE WATER</p>
<p class="books-by-text-1">ROMANCED TO DEATH *</p>
<p class="books-by-text-1">FULL CIRCLE *</p>
<p class="books-by-text-1">DEAD WEIGHT *</p>
<p class="books-by-text-1-space-after">GONE IN A FLASH *</p>
<h4 class="books-by-subtitle"><em>The Milt Kovak Series</em></h4>
<p class="books-by-text-1">THE MAN IN THE GREEN CHEVY</p>
<p class="books-by-text-1">HOUSTON IN THE REARVIEW MIRROR</p>
<p class="books-by-text-1">OTHER PEOPLE’S HOUSES</p>
<p class="books-by-text-1">CHASING AWAY THE DEVIL</p>
<p class="books-by-text-1">DEAD MOON ON THE RISE</p>
<p class="books-by-text-1">DOCTORS AND LAWYERS AND SUCH</p>
<p class="books-by-text-1">LYING WONDERS</p>
<p class="books-by-text-1">VEGAS NERVE</p>
<p class="books-by-text-1">SHOTGUN WEDDING *</p>
<p class="books-by-text-1">RUDE AWAKENING *</p>
<p class="books-by-text-1">HUSBAND AND WIVES *</p>
<p class="books-by-text-1-space-after">DARK WATERS *</p>
<p class="books-by-text">*  <em>available from Severn House</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?e6f974d8